// Team Metrics Mock Data
// 5 team members with realistic performance metrics

export const teamMembers = [
  {
    id: "tm-001",
    name: "Ana Silva",
    avatar: "AS",
    role: "Team Lead",
    color: "#f59e0b",
    tasksCompleted: 147,
    tasksInProgress: 8,
    responseTime: 0.8,
    satisfactionScore: 96.2,
    messagesHandled: 4521,
    resolutionRate: 89.3,
    weeklyHours: 42,
    trend: "up",
    trendValue: 12,
  },
  {
    id: "tm-002",
    name: "Carlos Mendes",
    avatar: "CM",
    role: "Senior Agent",
    color: "#0ea5e9",
    tasksCompleted: 132,
    tasksInProgress: 5,
    responseTime: 1.1,
    satisfactionScore: 94.8,
    messagesHandled: 3892,
    resolutionRate: 85.7,
    weeklyHours: 40,
    trend: "up",
    trendValue: 8,
  },
  {
    id: "tm-003",
    name: "Beatriz Costa",
    avatar: "BC",
    role: "Agent",
    color: "#10b981",
    tasksCompleted: 118,
    tasksInProgress: 12,
    responseTime: 1.4,
    satisfactionScore: 92.1,
    messagesHandled: 3245,
    resolutionRate: 81.2,
    weeklyHours: 38,
    trend: "up",
    trendValue: 5,
  },
  {
    id: "tm-004",
    name: "Diego Ferreira",
    avatar: "DF",
    role: "Agent",
    color: "#8b5cf6",
    tasksCompleted: 105,
    tasksInProgress: 7,
    responseTime: 1.6,
    satisfactionScore: 89.5,
    messagesHandled: 2876,
    resolutionRate: 78.4,
    weeklyHours: 36,
    trend: "down",
    trendValue: -3,
  },
  {
    id: "tm-005",
    name: "Elena Rodrigues",
    avatar: "ER",
    role: "Junior Agent",
    color: "#ec4899",
    tasksCompleted: 89,
    tasksInProgress: 15,
    responseTime: 2.1,
    satisfactionScore: 86.3,
    messagesHandled: 2134,
    resolutionRate: 72.1,
    weeklyHours: 32,
    trend: "up",
    trendValue: 15,
  },
];

// Leaderboard sorted by composite score
export const leaderboard = [...teamMembers]
  .map((m) => ({
    ...m,
    score: Math.round(
      m.tasksCompleted * 0.3 +
      m.satisfactionScore * 2 +
      m.resolutionRate * 1.5 -
      m.responseTime * 10
    ),
  }))
  .sort((a, b) => b.score - a.score)
  .map((m, i) => ({ ...m, rank: i + 1 }));

// Weekly team trend data
export const teamWeeklyTrend = [
  { week: "W1", tasks: 420, satisfaction: 88.5, responseTime: 1.5, resolution: 76.2 },
  { week: "W2", tasks: 458, satisfaction: 89.8, responseTime: 1.4, resolution: 78.1 },
  { week: "W3", tasks: 491, satisfaction: 91.2, responseTime: 1.3, resolution: 79.8 },
  { week: "W4", tasks: 531, satisfaction: 92.3, responseTime: 1.2, resolution: 81.5 },
];

// Team summary KPIs
export const teamSummary = {
  totalTasks: teamMembers.reduce((s, m) => s + m.tasksCompleted, 0),
  avgSatisfaction: parseFloat(
    (teamMembers.reduce((s, m) => s + m.satisfactionScore, 0) / teamMembers.length).toFixed(1)
  ),
  avgResponseTime: parseFloat(
    (teamMembers.reduce((s, m) => s + m.responseTime, 0) / teamMembers.length).toFixed(1)
  ),
  avgResolution: parseFloat(
    (teamMembers.reduce((s, m) => s + m.resolutionRate, 0) / teamMembers.length).toFixed(1)
  ),
  totalMessages: teamMembers.reduce((s, m) => s + m.messagesHandled, 0),
  activeMembers: teamMembers.length,
};
